import { useIntl } from '@capsicum/common';

export const useRecoveryKitGenerated = ({
	isReplacementKitAfterRecovery
}: {
	isReplacementKitAfterRecovery: boolean | undefined;
}) => {
	const { $t } = useIntl();

	const texts = {
		alertSubtitle: $t('ncOnboarding.recoveryKit.generateRecoveryKit.alertSubtitle'),
		alertTitle: $t('ncOnboarding.recoveryKit.generateRecoveryKit.alertTitle'),
		buttonContinue: $t('global.button.continue'),
		buttonCopySnack: $t('ncOnboarding.recoveryKit.buttonCopySnack'),
		buttonDownload: $t('ncOnboarding.recoveryKit.buttonDownload'),
		inputRecoveryCode: $t('ncOnboarding.recoveryKit.form.inputRecoveryCode'),
		inputRecoveryKeyId: $t('ncOnboarding.recoveryKit.form.inputRecoveryKeyId'),
		subtitle: $t('ncOnboarding.recoveryKit.subtitle'),
		title: isReplacementKitAfterRecovery
			? $t('ncOnboarding.recoveryKit.recoverWallet.newKitTitle')
			: $t('ncOnboarding.recoveryKit.title')
	};

	return texts;
};
